import React from "react";
import {useSubheader} from "../../_metronic/layout";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../_metronic/_helpers";
import {useTranslation} from "react-i18next";

export const SupportsPage = () => {
	const { t } = useTranslation('common');
	const suhbeader = useSubheader();
	suhbeader.setTitle(t('Support'));

	return (
		<>
			<div className='text-center'>
				<h2 className='my-4 mt-10'>{t('SupportNumber')}</h2>
        <h3 className='mb-10'>021-26297306</h3>

				<SVG
					src={toAbsoluteUrl(
						"/media/svg/illustrations/progress.svg"
					)}
				/>
			</div>
		</>
	);
};
